import PortalStudentProfile from '@classes/StudentProfile'
import { StoreProps } from '@interfaces/StoreState'
import ProgramSelector from '@layouts/Dashboard/HeroBlock/ProgramSelector'
import {
  updateDashboardActiveMaterial,
  updateDashboardActiveProgram,
  updateDashboardActiveRegistration,
} from '@redux/actions/dashboard'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

/**
 * This is a wrapper component that will help to initialize the active material
 * on page load. This is needed because the active material usually get data
 * from local storage and sometimes its not what we want to show on initial page load.
 *
 */
const HeroBlockInitializer = ({ children }) => {
  const dispatch = useDispatch()
  const { portalStudentInfo, activeRegistration, activeProgram, activeMaterial } = useSelector(
    ({ userProfile, dashboard }: StoreProps) => {
      const portalStudentInfo = userProfile?.info?.StudentProfile?.StudentProfileInfo
        ? new PortalStudentProfile(userProfile?.info?.StudentProfile?.StudentProfileInfo)
        : {
            MaterialDropDown: [],
            getActiveIdFromMaterialDropdown: () => ({ registrationId: '', programId: '', materialLPID: '' }),
            storeActiveDropdownIds: (
              activeDropdownRegistrationId: string,
              activeDropdownProgramId: string,
              activeDropdownLPId: string
            ) => '',
          }
      return {
        portalStudentInfo,
        activeRegistration: dashboard.activeRegistration,
        activeProgram: dashboard.activeProgram,
        activeMaterial: dashboard.activeMaterial,
      }
    }
  )

  /**
   * If it has activeMaterial then it means that the user has selected a material in program selector
   * therfore we use it as an active selected material otherwise we use the active material from the getActiveIdFromMaterialDropdown
   */
  const ActiveIdFromMaterialDropdown = portalStudentInfo?.getActiveIdFromMaterialDropdown()
  const selectedMaterial = activeMaterial || ActiveIdFromMaterialDropdown?.materialLPID
  const selectedRegistration = activeRegistration || ActiveIdFromMaterialDropdown?.registrationId
  const selectedProgram = activeProgram || ActiveIdFromMaterialDropdown?.programId

  useEffect(() => {
    if (
      !(activeMaterial && activeRegistration && activeProgram) &&
      selectedMaterial &&
      selectedRegistration &&
      selectedProgram
    ) {
      dispatch(updateDashboardActiveMaterial(selectedMaterial))
      dispatch(updateDashboardActiveRegistration(selectedRegistration))
      dispatch(updateDashboardActiveProgram(selectedProgram))
    }
  }, [])

  useEffect(() => {
    if (selectedMaterial && selectedRegistration && selectedProgram) {
      portalStudentInfo?.storeActiveDropdownIds(selectedRegistration, selectedProgram, selectedMaterial)
    }
  }, [selectedMaterial, selectedRegistration, selectedProgram])

  return (
    <>
      <ProgramSelector showCT defaultProgram={selectedMaterial} hide />
      {<>{children}</>}
    </>
  )
}

export default HeroBlockInitializer
